import { render } from "./Border.vue?vue&type=template&id=61d9bfe0"
const script = {}

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__